import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.define-property";
import n from "raf";
import { useState as t, useRef as r, useEffect as e, useCallback as o, useMemo as i } from "react";

function u(n, t, r) {
  return t in n ? Object.defineProperty(n, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : n[t] = r, n;
}

function a(n) {
  for (var t = 1; t < arguments.length; t++) {
    var r = null != arguments[t] ? arguments[t] : {},
        e = Object.keys(r);
    "function" == typeof Object.getOwnPropertySymbols && (e = e.concat(Object.getOwnPropertySymbols(r).filter(function (n) {
      return Object.getOwnPropertyDescriptor(r, n).enumerable;
    }))), e.forEach(function (t) {
      u(n, t, r[t]);
    });
  }

  return n;
}

function l(n, t) {
  if (null == n) return {};

  var r,
      e,
      o = function (n, t) {
    if (null == n) return {};
    var r,
        e,
        o = {},
        i = Object.keys(n);

    for (e = 0; e < i.length; e++) {
      r = i[e], t.indexOf(r) >= 0 || (o[r] = n[r]);
    }

    return o;
  }(n, t);

  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(n);

    for (e = 0; e < i.length; e++) {
      r = i[e], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(n, r) && (o[r] = n[r]);
    }
  }

  return o;
}

function c(n, t) {
  return function (n) {
    if (Array.isArray(n)) return n;
  }(n) || function (n, t) {
    var r = [],
        e = !0,
        o = !1,
        i = void 0;

    try {
      for (var u, a = n[Symbol.iterator](); !(e = (u = a.next()).done) && (r.push(u.value), !t || r.length !== t); e = !0) {
        ;
      }
    } catch (n) {
      o = !0, i = n;
    } finally {
      try {
        e || null == a["return"] || a["return"]();
      } finally {
        if (o) throw i;
      }
    }

    return r;
  }(n, t) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  }();
}

function f(n) {
  return function (n) {
    if (Array.isArray(n)) {
      for (var t = 0, r = new Array(n.length); t < n.length; t++) {
        r[t] = n[t];
      }

      return r;
    }
  }(n) || function (n) {
    if (Symbol.iterator in Object(n) || "[object Arguments]" === Object.prototype.toString.call(n)) return Array.from(n);
  }(n) || function () {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
  }();
}

var p = function p() {};

function s(n) {
  return n && n.current ? n.current.scrollHeight : "auto";
}

var y = function y() {
  for (var n = arguments.length, t = new Array(n), r = 0; r < n; r++) {
    t[r] = arguments[r];
  }

  return function () {
    for (var n = arguments.length, r = new Array(n), e = 0; e < n; e++) {
      r[e] = arguments[e];
    }

    return t.forEach(function (n) {
      return n && n.apply(void 0, r);
    });
  };
},
    d = {
  transitionDuration: "500ms",
  transitionTimingFunction: "cubic-bezier(0.250, 0.460, 0.450, 0.940)"
};

function h(n) {
  if (n) {
    var t = ["height"];
    return t.push.apply(t, f(n.split(", "))), t.join(", ");
  }

  return "height";
}

var g = 0,
    v = function v() {
  return ++g;
};

export default function () {
  var f,
      g,
      b,
      O = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
      m = function () {
    var n = c(t(null), 2),
        r = n[0],
        o = n[1];
    return e(function () {
      return o(v());
    }, []), r;
  }(),
      w = r(null),
      P = function (n) {
    var r = n.isOpen,
        e = n.defaultOpen,
        o = c(t(e || !1), 2),
        i = o[0];
    return [void 0 !== r ? r : i, o[1]];
  }(O),
      j = c(P, 2),
      S = j[0],
      x = j[1],
      A = "".concat(O.collapsedHeight || 0, "px"),
      E = i(function () {
    return {
      display: "0px" === A ? "none" : "block",
      height: A,
      overflow: "hidden"
    };
  }, [A]),
      k = i(function () {
    return t = (n = O).expandStyles, r = void 0 === t ? d : t, e = n.collapseStyles, o = void 0 === e ? d : e, {
      expandStyles: a({}, r, {
        transitionProperty: h(r.transitionProperty)
      }),
      collapseStyles: a({}, o, {
        transitionProperty: h(o.transitionProperty)
      })
    };
    var n, t, r, e, o;
  }, [O]),
      C = k.expandStyles,
      T = k.collapseStyles,
      I = c(t(S ? {} : E), 2),
      D = I[0],
      H = I[1],
      K = c(t(S), 2),
      z = K[0],
      F = K[1],
      q = o(function () {
    return x(function (n) {
      return !n;
    });
  }, []);

  f = function f() {
    n(S ? function () {
      F(!0), H(function (n) {
        return a({}, n, C, {
          willChange: "height",
          display: "block",
          overflow: "hidden"
        });
      }), n(function () {
        var n = s(w);
        H(function (t) {
          return a({}, t, {
            height: n
          });
        });
      });
    } : function () {
      var t = s(w);
      H(function (n) {
        return a({}, n, T, {
          willChange: "height",
          height: t
        });
      }), n(function () {
        H(function (n) {
          return a({}, n, {
            height: A,
            overflow: "hidden"
          });
        });
      });
    });
  }, g = [S], b = r(!0), e(function () {
    if (!b.current) return f();
    b.current = !1;
  }, g);

  var B = function B(n) {
    if (n.target === w.current) if (S) {
      var t = s(w);
      t === D.height ? H({}) : H(function (n) {
        return a({}, n, {
          height: t
        });
      });
    } else D.height === A && (F(!1), H(E));
  };

  return {
    getToggleProps: function getToggleProps() {
      var n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          t = n.disabled,
          r = void 0 !== t && t,
          e = n.onClick,
          o = void 0 === e ? p : e,
          i = l(n, ["disabled", "onClick"]);
      return a({
        type: "button",
        role: "button",
        id: "react-collapsed-toggle-".concat(m),
        "aria-controls": "react-collapsed-panel-".concat(m),
        "aria-expanded": S ? "true" : "false",
        tabIndex: 0
      }, i, {
        onClick: r ? p : y(o, q)
      });
    },
    getCollapseProps: function getCollapseProps() {
      var n,
          t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          r = t.style,
          e = void 0 === r ? {} : r,
          o = t.onTransitionEnd,
          i = void 0 === o ? p : o,
          c = t.refKey,
          f = void 0 === c ? "ref" : c,
          s = l(t, ["style", "onTransitionEnd", "refKey"]);
      return a({
        id: "react-collapsed-panel-".concat(m),
        "aria-hidden": S ? null : "true"
      }, s, (u(n = {}, f, w), u(n, "onTransitionEnd", y(B, i)), u(n, "style", a({}, d, e, {
        transitionProperty: h(e.transitionProperty)
      }, D)), n));
    },
    isOpen: S,
    toggleOpen: q,
    mountChildren: z
  };
}